import { Component, OnDestroy, OnInit } from '@angular/core'
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { Router } from '@angular/router'
import { Subscription } from 'rxjs'
import { NotificationService } from '../../../notification/shared/notification.service'
import { Client } from '../../shared/client/client'
import { ClientService } from '../../shared/client/client.service'
import { Contact } from '../shared/contact'
import { ContactService } from '../shared/contact.service'
import { SavService } from '../shared/sav.service'

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss']
})
export class ContactFormComponent implements OnInit, OnDestroy {

  reclamation = "Réclamation"
  autre = "Autre demande"

  filename = "Aucun fichier sélectionné"

  motifs = []
  files = []

  savInfo: Contact
  load: boolean = true
  sendingForm: boolean = false

  subClient: Subscription

  currentClient: Client

  constructor(private contactService: ContactService,
    private notification: NotificationService,
    private savService: SavService,
    private router: Router,
    private clientService: ClientService
  ) { }

  ngOnInit() {
    this.getMotifs()

    this.subClient = this.clientService.getCurrentClient().subscribe(client => {
      this.currentClient = client
      this.savService.getSavDefault(this.currentClient).subscribe(savDefault => {
        if (savDefault) {
          this.savInfo = savDefault
        }
        this.load = false
      })
    })

    this.contactForm.get('type').valueChanges.subscribe(type => {
      if (type == this.reclamation) {
        this.contactForm.controls['description'].setValidators([
          Validators.required,
          Validators.minLength(150)
        ])
      } else {
        this.contactForm.controls['description'].setValidators([
          Validators.required,
          Validators.minLength(50)
        ])
      }
    })
  }

  ngOnDestroy(): void {
    if (this.subClient) {
      this.subClient.unsubscribe()
    }
  }

  contactForm: UntypedFormGroup = new UntypedFormGroup({
    'type': new UntypedFormControl('', [
      Validators.required
    ]),
    'motif': new UntypedFormControl('', [
      Validators.required,
      Validators.maxLength(100)
    ]),
    'description': new UntypedFormControl('', [
      Validators.required,
      Validators.minLength(50)
    ])
  })

  submitForm(): void {
    if (this.contactForm.valid) {
      this.sendingForm = true
      // enregistre la réclamation ou la demande sur amadeus
      // gestion des pièces jointes
      if (this.contactForm.value.type == this.reclamation) {
        let query = { motif: this.contactForm.value.motif, description: this.contactForm.value.description, fichier1: this.files[0], fichier2: this.files[1], fichier3: this.files[2] };
        this.contactService.sendReclamation(this.currentClient, query).subscribe(response => {
          this.notification.notif(response, 'notif', 5000).afterOpened().subscribe(
            () => this.router.navigate(['/']),
            error => this.sendingForm = false
          )
        },
          error => this.sendingForm = false)
      } else {
        let query = { motif: this.contactForm.value.motif, description: this.contactForm.value.description, fichier1: this.files[0], fichier2: this.files[1], fichier3: this.files[2] };
        this.savService.askRdv(this.currentClient, query).subscribe(
          response => this.notification.notif(response, 'notif').afterOpened().subscribe(
            () => this.router.navigate(['/']),
            error => this.sendingForm = false
          ),
          error => this.sendingForm = false
        )
      }
    }
  }

  getMotifs() {
    this.contactService.getMotifs().subscribe(data => {
      data.push(data.splice(data.findIndex((el) => el.libelle == 'Autres'), 1)[0])
      this.motifs = data
    })
  }

  async onFileSelected() {
    const inputNode: any = document.querySelector('#file')

    for (var i = 0; i < inputNode.files['length']; i++) {
      let file = inputNode.files[i]
      if (this.files.length > 2) {
        this.notification.notif("Vous ne pouvez pas ajouter plus de 3 fichiers", 'warn')
        break
      } else if (file.size > 10000000) {
        this.notification.notif("le fichier " + file.name + " est trop volumineux", 'warn')
      } else if (this.files.filter(el => el.name == file.name).length > 0) {
        this.notification.notif("le fichier " + file.name + " a déjà été importé", 'warn')
      } else {
        await this.fileToDataURL(file).then((value) => {
          this.files.push({ name: file.name, type: file.type, fileURL: value })
        })
      }
    }
  }

  fileToDataURL(file_: File) {
    const reader = new FileReader()
    return new Promise((resolve, reject) => {
      reader.readAsDataURL(file_)
      reader.addEventListener(
        'load',
        function (event) {
          resolve(event.target.result)
        },
        false,
      )
    })
  }

  deleteFile(file) {
    this.files.splice(this.files.indexOf(file), 1)
  }
}
